import React, { Component } from "react"
import intl from "react-intl-universal"
import { getProjectList } from "../../../api/project/Project"
import cookie from 'react-cookies'

import { Table, Space, Spin, Select, Pagination, Button, Modal } from 'antd'
import "./content.css"
import 'bootstrap/dist/css/bootstrap.css'
import UsageChart from "../../../components/charts/UsageChart"
import ProjectModel from "../../../components/modal/project/ProjectModel"
import ServiceCard from "./ServiceCard"

const { Option } = Select

class Content extends Component {

    projectRef = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            projectList: [],
            totalSize: 0,
            currentPage: 1,
            pageSize: 4,
            service: 99,
            loading: true,
            serviceTrend: 99,
            isModalOpen: cookie.load('risk-modal-hidden') ? false : false, //“两会风控升级”弹窗，已废弃
        }
        
        this.changeService = this.changeService.bind(this)
        this.changeTrendService = this.changeTrendService.bind(this)
        this.getProjectList = this.getProjectList.bind(this)
        this.changePage = this.changePage.bind(this)

        this.showCreateProjectModal = this.showCreateProjectModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
    }


    componentWillMount () {
        this.getProjectList()
    }

    changeService (service) {
        this.setState({
            currentPage: 1,
            service: service,
            loading: true,
        }, this.getProjectList)
    }

    getProjectList () {
        let that = this
        let { service, currentPage, pageSize } = that.state
        getProjectList(service, currentPage, pageSize).then((res) => {
            // console.log("get projects response:", res);
            if (res.code === 0) {
                that.setState({
                    projectList: res.data.projectList,
                    totalSize: res.data.total,
                    loading: false
                })
            }
        }, (error) => {
            console.log("get response failed!")
        }
        )
    }

    changePage (page, pageSize) {
        this.setState({
            currentPage: page,
            pageSize: pageSize,
            loading: true,
        }, this.getProjectList)
    }

    changeTrendService (service) {
        this.setState({
            serviceTrend: service,
        })
    }

    showCreateProjectModal (service = '') {
        this.projectRef?.current?.showModal?.(service)
    }
       
    hideModal () {
        this.setState({
            isModalOpen: false,
        })
        cookie.save('risk-modal-hidden', 1)
    };

    render () {
        const { userInfo, serviceIdList } = this.props
        const { projectList, loading, totalSize, currentPage, pageSize, isModalOpen } = this.state

        const columns = [
            {
                title: intl.get('console.pro_name'),
                dataIndex: 'name',
                fixed: 'left',
                width: 150,
            },
            {
                title: intl.get('console.service'),
                dataIndex: 'serviceName',
                width: 150,
            },
            {
                title: intl.get('console.status'),
                dataIndex: 'statusName',
                width: 100,
            },
            {
                title: intl.get('console.child_cy'),
                dataIndex: 'companyName',
            },
            {
                title: intl.get('console.create_time'),
                dataIndex: 'created_at',
            },
            {
                title: intl.get('console.operation'),
                dataIndex: 'action',
                width: 160,
                fixed: 'right',
                render: (text, record) => {
                    if (global.serviceInfoMap[record.service]) {
                        return (
                            <Space size="middle">
                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + global.serviceInfoMap[record.service].dsUrl + '?pid=' + record.pid}>{intl.get('console.btn_see')}</a>
                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + global.serviceInfoMap[record.service].usageUrl + '?pid=' + record.pid}>{intl.get('console.btn_usage')}</a>
                            </Space>
                        )
                    }

                }
            },
        ]

        let options = serviceIdList.map((service) =>
            <Option key={global.serviceInfoMap[service].value} value={global.serviceInfoMap[service].value}>{global.serviceInfoMap[service].label}</Option>
        )

        return (
            <div>
                <div className="welcome">
                    <div style={{ width: '100%', display: 'flex', justifyContent: "space-between", padding: '0 20px' }}>
                        <div>
                            {intl.get('sys.HELLO', { name: userInfo.name })}
                        </div>
                        <div>
                            <a href={process.env.REACT_APP_OLD_CONSOLE_URL + '/console/dashboard/index'}>{intl.get('console.back_old_console')}</a>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div style={{ padding: '16px 12px 70px 12px' }}>
                        <div className="row mb-3" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12 col-lg-8 screen990" style={{ padding: '0 8px' }}>
                                <div className="bg-white mb-3">
                                    <div className="a-card-header border-0">
                                        <div className="mx-2 d-flex justify-content-between align-items-center">
                                            <div>{intl.get('console.overview')}</div>
                                            <div className="font-LH-14 color-black-85 font-weight-normal">
                                                <Select defaultValue={intl.get('console.all_s')} bordered={false}
                                                    onChange={this.changeService}
                                                    dropdownClassName={global.appLang === 'en-US' ? "en-dropdown-select" : ""}>
                                                    {options}
                                                </Select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="px-4 pb-3">
                                        <Spin spinning={loading}>
                                            <Table columns={columns} dataSource={projectList} pagination={false} rowKey="id" scroll={{ x: 'max-content' }} style={{ overflow: 'hidden' }} />
                                            <div className="mt-3 text-right">
                                                <Pagination current={currentPage} pageSize={pageSize}
                                                    total={totalSize} showTotal={(total) => `Total ${Math.ceil(totalSize / pageSize)} pages`}
                                                    onChange={this.changePage} />
                                            </div>
                                        </Spin>
                                    </div>
                                </div>

                                <div className="bg-white">
                                    <div className="a-card-header">
                                        <div className="mx-2 d-flex justify-content-between align-items-center">
                                            <div>{intl.get('console.time_usage')}</div>
                                            <div className="font-LH-14 color-black-85 font-weight-normal">
                                                <Select defaultValue={intl.get('console.all_s')} bordered={false}
                                                    onChange={this.changeTrendService}
                                                    dropdownClassName={global.appLang === 'en-US' ? "en-dropdown-select" : ""}>
                                                    {options}
                                                </Select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="px-4 py-3">
                                        <UsageChart service={this.state.serviceTrend} />
                                    </div>

                                </div>
                            </div>

                            {/*右侧*/}
                            <div className="col-12 col-lg-4" style={{ padding: '0 8px' }}>
                                {/*服务引导*/}
                                <div className="bg-white mb-3">
                                    <div className="a-card-header">{intl.get('console.service_yd')}</div>
                                    <div className="text-center" style={{ padding: '36px', cursor: 'pointer' }} onClick={this.showCreateProjectModal}>
                                        <img src={process.env.PUBLIC_URL + '/assets/image/console/index/icon-docs-plus.png'} width="32" style={{ marginRight: '12px' }} alt="" />
                                        <span className="font-LH-16" style={{ color: '#1890FF' }}>{intl.get('console.btn_new_project')}</span>
                                    </div>
                                    <ProjectModel ref={this.projectRef} callback={this.getProjectList}></ProjectModel>
                                    <div className="row m-0" style={{ borderTop: '1px solid #F0F0F0' }} >
                                        <div className="col-6" style={{ padding: '24px 20px' }}>
                                            <a href="https://docs.ilivedata.com/" target="_blank" rel="noopener noreferrer">
                                                <div className="mb-2">
                                                    <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-page.png"} width="20" style={{ marginRight: '12px' }} alt="" />
                                                    <span className="font-LH-14 color-black-85">{intl.get('console.href_doc')}</span>
                                                </div>
                                                <div className="font-LH-14 color-black-45">{intl.get('console.text_2')}</div>
                                            </a>
                                        </div>
                                        <div className="col-6" style={{ padding: '24px 20px', borderLeft: '1px solid #F0F0F0' }}>
                                            <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/trial/translator"} target="_blank" rel="noopener noreferrer">
                                                <div className="mb-2">
                                                    <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-smile.png"} width="20" style={{ marginRight: '12px' }} alt="" />
                                                    <span className="font-LH-14 color-black-85">{intl.get('console.href_demo')}</span>
                                                </div>
                                                <div className="font-LH-14 color-black-45">{intl.get('console.text_3')}</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                {/*常用链接*/}
                                <div className="bg-white mb-3">
                                    <div className="a-card-header">{intl.get('console.link')}</div>
                                    <div className="card-header-link" style={{ padding: '16px 12px' }}>
                                        <div className="row m-0" style={{ overflow: 'hidden' }}>
                                            <div className="col-6 p-2">
                                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/console/rtm/dashboard/index"}>
                                                    <div className="links">
                                                        {intl.get('sys.rtm_0')}
                                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-link.png"} width="14" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-6 p-2">
                                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/console/pir/dashboard/index"}>
                                                    <div className="links">
                                                        {intl.get('sys.pir_10')}
                                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-link.png"} width="14" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-6 p-2">
                                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/console/dts/dashboard/index"}>
                                                    <div className="links">
                                                        {intl.get('sys.dts_7')}
                                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-link.png"} width="14" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-6 p-2">
                                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/console/alt/dashboard/index"}>
                                                    <div className="links">
                                                        {intl.get('sys.alt_4')}
                                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-link.png"} width="14" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-6 p-2">
                                                <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/console/stt/dashboard/index"}>
                                                    <div className="links">
                                                        {intl.get('sys.stt_8')}
                                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/icon-link.png"} width="14" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*零门槛试用*/}
                                <div className="bg-white d-flex justify-content-between">
                                    <div className="console-try-box">
                                        <div className="font-LH-16 color-black-85 mb-1">{intl.get('console.href_try')}</div>
                                        <div className="font-LH-14 color-black-45" style={{ marginBottom: '20px' }}>
                                            {intl.get('console.text_1')}
                                        </div>
                                        <a href={process.env.REACT_APP_OLD_CONSOLE_URL + "/trial/index"} target="_blank" rel="noopener noreferrer">
                                            <Button className="rounded-2">{intl.get('console.href_free_try')}</Button>
                                        </a>
                                    </div>
                                    <div style={{ marginTop: '30px', marginRight: '20px', maxWidth: '203px', maxHeight: '167px', }} >
                                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/free-trial.png"} style={{ maxWidth: '100%', maxHeight: '100%' }} alt="" />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="row pb-3" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12" style={{ padding: '0 8px' }}>
                                <div className="bg-white mb-3">
                                    <div className="a-card-header border-0">
                                        <div className="mx-2 d-flex justify-content-between align-items-center">
                                            <div>{intl.get('console.service_tj')}</div>
                                            <div className="font-LH-14 color-black-85 font-weight-normal">

                                            </div>
                                        </div>
                                    </div>

                                    <div className="px-4 pb-3">
                                        <ServiceCard callback={this.showCreateProjectModal}></ServiceCard>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                <Modal
                    title={null}
                    width={420}
                    className="risk-model"
                    visible={isModalOpen}
                    footer={null}
                    maskClosable={false}
                    closable={false}>
                    <div style={{margin: '-24px'}}>
                        <img src={process.env.PUBLIC_URL + "/assets/image/console/index/notify_img.png"} width="420" height="147" alt="" />
                        <div style={{padding: '32px 50px'}}>
                            <ul style={{fontSize: '14px', lineHeight: '22px', color: '#434343', margin: 0, padding: '0 0 0 6px'}}>
                                <li style={{marginBottom: '15px'}}>
                                介于 2023 年全国两会将于 3 月 4 日至 5 日召开，我司将于 3 月 1 日至 7 日收紧各类审核产品相关涉政策略，全面强化实时热点布控。
                                </li>
                                <li style={{marginBottom: '14px'}}>
                                若涉及任何诉求，欢迎您随时联系我司相关人员。
                                </li>
                                <li style={{marginBottom: '24px'}}>
                                云上曲率秉持着客户至上的标准，全程守护您的内容安全。
                                </li>
                            </ul>
                            <div style={{
                                backgroundColor: '#0065FF', 
                                borderRadius: '2px', 
                                color: '#FFFFFF', 
                                fontSize: '18px', 
                                lineHeight: '30px', 
                                fontWeight: '500', 
                                textAlign: 'center',
                                paddingTop: '7px',
                                paddingBottom: '7px',
                                cursor: 'pointer'
                                }} 
                                onClick={this.hideModal}>
                                我知道了
                                </div>
                        </div>
                    </div>
                </Modal>
                </div>
            </div>
        )
    }

}


export default Content
